import React from "react";
import { MuiThemeProvider } from "@material-ui/core";
import { lightTheme, darkTheme, RemoTheme } from "@remo-co/ui-core/theme";

export interface IProviderProps {
  children?: React.ReactNode;
  theme?: RemoTheme;
}

const Provider = ({ children, theme = RemoTheme.light }: IProviderProps) => (
  <MuiThemeProvider theme={theme === RemoTheme.light ? lightTheme : darkTheme}>
    {children}
  </MuiThemeProvider>
);

export default Provider;
